module.exports = __webpack_public_path__ + "img/chart.23fdf23c.svg";